function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconCategorySalary");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}));

var SvgIconEmployeeBadge = function SvgIconEmployeeBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Academy-New-concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-130.000000, -781.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-Academy-V2-Copy-2",
    transform: "translate(100.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-items",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Not-expanded",
    transform: "translate(30.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-item",
    transform: "translate(0.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id-card-1"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(1.666667, 2.500000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M15.0008333,1.66666667 L10.68,1.66666667 C10.335,0.698333333 9.41833333,0 8.33416667,0 C7.24916667,0 6.33333333,0.698333333 5.98833333,1.66666667 L1.6675,1.66666667 C0.748333333,1.66666667 0.000833333333,2.41416667 0.000833333333,3.33333333 L0.000833333333,13.3333333 C0.000833333333,14.2525 0.748333333,15 1.6675,15 L15.0008333,15 C15.92,15 16.6675,14.2525 16.6675,13.3333333 L16.6675,3.33333333 C16.6675,2.41416667 15.92,1.66666667 15.0008333,1.66666667 Z M5.00083333,5 C5.92083333,5 6.6675,5.74666667 6.6675,6.66666667 C6.6675,7.58666667 5.92083333,8.33333333 5.00083333,8.33333333 C4.08083333,8.33333333 3.33416667,7.58666667 3.33416667,6.66666667 C3.33416667,5.74666667 4.08083333,5 5.00083333,5 Z M2.50083333,11.6666667 C2.50083333,10.1325 3.46666667,9.16666667 5.00083333,9.16666667 C6.535,9.16666667 7.50083333,10.1325 7.50083333,11.6666667 L2.50083333,11.6666667 Z M8.33416667,3.33333333 C7.875,3.33333333 7.50083333,2.95916667 7.50083333,2.5 C7.50083333,2.04083333 7.875,1.66666667 8.33416667,1.66666667 C8.79333333,1.66666667 9.1675,2.04083333 9.1675,2.5 C9.1675,2.95916667 8.79333333,3.33333333 8.33416667,3.33333333 Z M14.1675,11.6666667 L9.1675,11.6666667 L9.1675,10 L14.1675,10 L14.1675,11.6666667 Z M14.1675,8.33333333 L9.1675,8.33333333 L9.1675,6.66666667 L14.1675,6.66666667 L14.1675,8.33333333 Z",
    id: "Shape"
  }))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEmployeeBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-employee-badge.346f1959.svg";
export { ForwardRef as ReactComponent };